import { LeadActions, LeadState, InitialStateLead, GET_LEAD, GET_LEAD_SUCCESS, GET_LEAD_ERROR } from './types'

const LeadReducer = (state: LeadState = InitialStateLead, action: LeadActions): LeadState => {
  switch (action.type) {
    case GET_LEAD:
      return {
        ...state,
        loading: true,
        error: false,
      }
    case GET_LEAD_SUCCESS:
      return {
        ...state,
        url: action.payload,
        loading: false,
        error: false,
      }
    case GET_LEAD_ERROR:
      return {
        ...state,
        url: null,
        loading: false,
        error: true,
      }
    default:
      return state
  }
}

export default LeadReducer
